var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.015 0H1.98499V512H510.015V0Z",
    fill: "#C8414B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M510.015 107.79H1.98499V404.21H510.015V107.79Z",
    fill: "#FFD250"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.347 256.409L231.538 223.005C232.292 219.929 229.709 217.011 226.232 217.011H220.462C216.985 217.011 214.401 219.929 215.156 223.005L223.347 256.409Z",
    fill: "#C8414B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.003 238.89H213.681V313.31H233.003V238.89Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.845 230.14H208.861V238.896H237.845V230.14Z",
    fill: "#FAB446"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.831 256.41H189.531V265.166H237.831V256.41Z",
    fill: "#C8414B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.839 291.429L208.856 282.674V273.919L237.839 282.674V291.429Z",
    fill: "#C8414B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.435 256.409L86.626 223.005C87.38 219.929 84.797 217.011 81.32 217.011H75.55C72.073 217.011 69.489 219.929 70.244 223.005L78.435 256.409Z",
    fill: "#C8414B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.248 230.143C106.913 230.143 102.587 234.062 102.587 238.899V295.807C102.587 306.445 113.542 326.45 150.892 326.45C188.242 326.45 199.197 306.444 199.197 295.807V238.899C199.197 234.064 194.872 230.143 189.536 230.143H112.248Z",
    fill: "#F5F5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.891 273.919H102.586V239.34C102.586 234.261 106.704 230.143 111.783 230.143H150.89V273.919H150.891Z",
    fill: "#C8414B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.891 273.919H199.196V294.703C199.196 307.401 188.902 317.695 176.204 317.695H173.884C161.186 317.695 150.892 307.401 150.892 294.703L150.891 273.919Z",
    fill: "#C8414B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.587 273.919H150.892V294.703C150.892 307.401 140.598 317.695 127.9 317.695H125.58C112.882 317.695 102.588 307.401 102.588 294.703L102.587 273.919Z",
    fill: "#FAB446"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.231 313.218V273.919H131.57V317.253C135.162 316.592 138.41 315.15 141.231 313.218Z",
    fill: "#C8414B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.909 317.253V273.919H112.248V313.218C115.069 315.15 118.316 316.592 121.909 317.253Z",
    fill: "#C8414B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141.225 256.41H112.241V265.166H141.225V256.41Z",
    fill: "#FFB441"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M141.225 238.89H112.241V247.646H141.225V238.89Z",
    fill: "#FAB446"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.403 244.1H117.081V259.961H136.403V244.1Z",
    fill: "#FAB446"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.096 238.89H68.774V313.31H88.096V238.89Z",
    fill: "#F5F5F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.925 308.94H63.941V317.696H92.925V308.94Z",
    fill: "#FAB446"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M92.925 230.14H63.941V238.896H92.925V230.14Z",
    fill: "#FAB446"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.754 317.7H59.111V326.456H97.754V317.7Z",
    fill: "#5064AA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M242.665 308.94H213.681V317.696H242.665V308.94Z",
    fill: "#FAB446"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M242.674 317.7H204.031V326.456H242.674V317.7Z",
    fill: "#5064AA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M179.878 221.39H121.911V230.146H179.878V221.39Z",
    fill: "#FAB446"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M155.722 195.13H146.061V221.4H155.722V195.13Z",
    fill: "#FFB441"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M141.231 208.255C133.24 208.255 126.74 202.364 126.74 195.123C126.74 187.882 133.24 181.991 141.231 181.991C149.222 181.991 155.722 187.882 155.722 195.123C155.721 202.364 149.221 208.255 141.231 208.255ZM141.231 190.745C138.566 190.745 136.401 192.708 136.401 195.123C136.401 197.538 138.566 199.501 141.231 199.501C143.896 199.501 146.061 197.538 146.061 195.123C146.061 192.707 143.896 190.745 141.231 190.745Z",
    fill: "#F5F5F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M160.552 208.255C152.561 208.255 146.061 202.364 146.061 195.123C146.061 187.882 152.561 181.991 160.552 181.991C168.543 181.991 175.043 187.882 175.043 195.123C175.042 202.364 168.543 208.255 160.552 208.255ZM160.552 190.745C157.887 190.745 155.722 192.708 155.722 195.123C155.722 197.538 157.887 199.501 160.552 199.501C163.217 199.501 165.382 197.538 165.382 195.123C165.382 192.707 163.217 190.745 160.552 190.745Z",
    fill: "#F5F5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M179.874 217.011C171.883 217.011 165.383 211.12 165.383 203.879C165.383 196.638 171.883 190.747 179.874 190.747C187.865 190.747 194.365 196.638 194.365 203.879C194.365 211.12 187.864 217.011 179.874 217.011ZM179.874 199.5C177.209 199.5 175.044 201.463 175.044 203.878C175.044 206.293 177.209 208.256 179.874 208.256C182.539 208.256 184.704 206.293 184.704 203.878C184.704 201.462 182.539 199.5 179.874 199.5Z",
    fill: "#F5F5F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M121.909 217.011C113.918 217.011 107.418 211.12 107.418 203.879C107.418 196.638 113.918 190.747 121.909 190.747C129.9 190.747 136.4 196.638 136.4 203.879C136.399 211.12 129.899 217.011 121.909 217.011ZM121.909 199.5C119.244 199.5 117.079 201.463 117.079 203.878C117.079 206.293 119.244 208.256 121.909 208.256C124.574 208.256 126.739 206.293 126.739 203.878C126.739 201.462 124.574 199.5 121.909 199.5Z",
    fill: "#F5F5F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M179.874 291.429V295.807C179.874 298.221 177.707 300.185 175.044 300.185C172.381 300.185 170.214 298.221 170.214 295.807V291.429H179.874ZM189.534 282.674H160.551V295.806C160.551 303.047 167.052 308.938 175.042 308.938C183.033 308.938 189.533 303.047 189.533 295.806L189.534 282.674Z",
    fill: "#FAB446"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M175.507 265.163H174.579C169.5 265.163 165.382 261.045 165.382 255.966V248.094C165.382 243.015 169.5 238.897 174.579 238.897H175.507C180.586 238.897 184.704 243.015 184.704 248.094V255.966C184.704 261.047 180.586 265.163 175.507 265.163Z",
    fill: "#FFA0D2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.891 287.05C158.894 287.05 165.382 281.172 165.382 273.92C165.382 266.669 158.894 260.79 150.891 260.79C142.888 260.79 136.4 266.669 136.4 273.92C136.4 281.172 142.888 287.05 150.891 287.05Z",
    fill: "#5064AA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M155.722 177.61H146.061V203.88H155.722V177.61Z",
    fill: "#FAB446"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121.909 221.388L112.248 212.632L117.907 207.503C126.655 199.575 138.52 195.122 150.891 195.122C163.262 195.122 175.128 199.576 183.875 207.503L189.534 212.632L179.873 221.388H121.909Z",
    fill: "#C8414B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M150.891 217.008C153.559 217.008 155.721 215.048 155.721 212.63C155.721 210.212 153.559 208.252 150.891 208.252C148.224 208.252 146.061 210.212 146.061 212.63C146.061 215.048 148.224 217.008 150.891 217.008Z",
    fill: "#FFD250"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M131.571 217.008C134.239 217.008 136.401 215.048 136.401 212.63C136.401 210.212 134.239 208.252 131.571 208.252C128.903 208.252 126.741 210.212 126.741 212.63C126.741 215.048 128.903 217.008 131.571 217.008Z",
    fill: "#FFD250"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M170.211 217.008C172.879 217.008 175.041 215.048 175.041 212.63C175.041 210.212 172.879 208.252 170.211 208.252C167.543 208.252 165.381 210.212 165.381 212.63C165.381 215.048 167.543 217.008 170.211 217.008Z",
    fill: "#FFD250"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M112.241 256.41H63.941V265.166H112.241V256.41Z",
    fill: "#C8414B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M63.943 291.429L92.926 282.674V273.919L63.943 282.674V291.429Z",
    fill: "#C8414B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/ES.c8f00944fdcd76e56ea4d5baedc9cd68.svg";
export { ForwardRef as ReactComponent };